var React = require('react');

function MobileLines (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#DAE0E5","strokeLinecap":"round","strokeWidth":"2","d":"M1.79 1.121v86.466h110.346V181"}));
}

MobileLines.defaultProps = {"height":"182","width":"114","viewBox":"0 0 114 182"};

module.exports = MobileLines;

MobileLines.default = MobileLines;
